import { Box, useMediaQuery } from '@mui/material'
import { Position } from 'interface'
import React, { useRef, useEffect } from 'react'

interface Props {
  imgPath?: string
  positions?: Position[]
}

export default function CanvasImg({ imgPath = '', positions = [] }: Props) {
  const md = useMediaQuery('min-width:600')
  const canvasRef = useRef({} as HTMLCanvasElement)
  useEffect(() => {
    if (canvasRef.current && imgPath) {
      const ctx = canvasRef.current.getContext('2d')
      const img = new Image()
      img.src = imgPath
      img.onload = function () {
        canvasRef.current.width = 360
        canvasRef.current.height = (360 * img.height) / img.width
        if (ctx) {
          ctx.drawImage(img, 0, 0, 360, (360 * img.height) / img.width)
          positions.forEach(({ x, y, size }, i) => {
            ctx.fillStyle = '#fff'
            ctx.fillRect(x - size / 2, y - size / 2, size, size)
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.font = '20px serif'
            ctx.fillStyle = '#00f'
            ctx.fillText((i + 1).toString(), x, y)
            ctx.beginPath()
            ctx.strokeStyle = '#00f'
            ctx.rect(x - size / 2, y - size / 2, size, size)
            ctx.stroke()
          })
        }
      }
    }
  }, [canvasRef, imgPath, positions])

  return (
    <Box
      component="canvas"
      border={1}
      borderColor="#999"
      width={md ? 360 : 300}
      ref={canvasRef}
    />
  )
}
